import React from 'react';
import { StyleSheet } from 'react-native';

import { Box } from '@/components/lib/components';
import { designSystem, withOpacity } from '@/styles/styles';

export const SubmissionOverlay = () => <Box style={styles.overlay} />;

const styles = StyleSheet.create({
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: withOpacity(designSystem.colors.neutralBlack, 0.5),
        // Keep the overlay above z-indexed siblings (e.g. the balance button) on Android, which orders by z rather than render order.
        zIndex: 10,
        elevation: 10,
    },
});
